module.exports = __webpack_public_path__ + "assets/img/title.a4f65c64.svg";